export default __webpack_public_path__ + "static/media/frequency.385568a4.svg";